import { render } from "./AdminShiftEdit.vue?vue&type=template&id=be6f4cc8&scoped=true&ts=true"
import script from "./AdminShiftEdit.vue?vue&type=script&lang=ts"
export * from "./AdminShiftEdit.vue?vue&type=script&lang=ts"

import "./AdminShiftEdit.vue?vue&type=style&index=0&id=be6f4cc8&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be6f4cc8"]])

export default __exports__